<template>
  <i18n path="manage.sort-by-order" tag="div" class="sort" :class="`text-${textVariant}`">
    <template v-slot:sortOrder>
      <b-dropdown :class="`text-${textVariant}`" right variant="transparent"
        :text="selectedValue" :toggle-class="`text-${textVariant}`">
          <b-dropdown-item v-for="(value, key) in options" :key="key"
            :class="`text-${textVariant}`" @click="select(key)">{{getTranslatedSortOrder(key)}}</b-dropdown-item>
      </b-dropdown>
    </template>
  </i18n>
</template>

<script>
export default {
  name: 'sort',
  props: {
    options: {
      type: Object,
      default: () => null,
    },
    i18nPrefix: {
      type: String,
      default: () => null,
    },
    textVariant: {
      type: String,
      default: () => 'secondary',
    },
    value: {
      type: String,
      default: () => null,
    },
  },
  computed: {
    selectedValue() {
      return this.getTranslatedSortOrder(this.value || 'default');
    },
  },
  methods: {
    getTranslatedSortOrder(key) {
      return this.i18nPrefix ? this.$t(`${this.i18nPrefix}.${key}`) : this.options[key];
    },
    select(key) {
      this.$emit('input', key);
    },
  },
};
</script>

<style lang="scss">
.sort {
  font-size: 15px;

  .title {
    margin-top: 1px;
    margin-right: 2px;
    margin-left: 2px;
    font-weight: 300
  }

  .dropdown {
    font-size: 16px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    text-align: center;

    .btn {
      // white-space: inherit;
      font-size: inherit;
      border: inherit;

      padding-top: inherit;
      padding-right: inherit;
      padding-bottom: inherit;
      padding-left: inherit;

      &.dropdown-toggle {
        border-bottom-width: 1px;
        border-bottom-style: solid;
        border-radius: inherit;
      }
    }
  }

  a.dropdown-item {
    color: inherit !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/misc/Sort.vue